/*
    UI Custom HTML Elements using signal-js events
*/

import signal from 'signal-js';

class SimpleToolbar extends HTMLElement {
    static get observedAttributes() { return ['position']; }
    constructor() {
        super();
        this.position = 'top left'
    }
    connectedCallback() {

    }

    disconnectedCallback() {

    }

    attributeChangedCallback(name, oldValue, newValue) {
        if (name == "position")
            this.position = newValue;
        this.updateStyle();
    }
    updateStyle() {
        this.style.position = 'absolute';
        this.style.display = 'flex';
        this.style.zIndex = 999;
        if (this.position.toLowerCase().indexOf('left') >= 0) {
            this.style.left = '0px';
        }
        if (this.position.toLowerCase().indexOf('right') >= 0) {
            this.style.right = '0px';
        }
        if (this.position.toLowerCase().indexOf('top') >= 0) {
            this.style.top = '0px';
        }
        if (this.position.toLowerCase().indexOf('bottom') >= 0) {
            this.style.bottom = '0px';
        }
        if (this.position.toLowerCase().indexOf('center') >= 0) {
            this.style.left = '50%';
            this.style.transform = 'translate(-50%, 0)'
        }
    }
}

class SimpleButton extends HTMLElement {
    static get observedAttributes() { return ['icon', 'action', 'params', 'disabled']; }
    constructor() {
        super();

        this.addEventListener('click', (event) => {
            if (!this.disabled && this.action)
                signal.emit(this.action, this.params ? this.params : null);
        })

    }
    connectedCallback() {
        this.style = 'display: block; padding: 1em; background-color: #ff0066; color: white; font-weight: bold';
        this.updateStyle();
    }

    disconnectedCallback() {

    }

    attributeChangedCallback(name, oldValue, newValue) {
        if (name == 'params')
            this.params = newValue;
        if (name == 'icon') {

            this.icon = newValue;
        }
        if (name == 'action')
            this.action = newValue;
        if (name == 'disabled') {
            if (newValue == null)
                this.disabled = false;
            else
                this.disabled = true;
        }
        this.updateStyle();
    }

    updateStyle() {
        if (this.disabled) {
            this.style.opacity = 0.5;
            this.style.cursor = 'not-allowed';
        } else {
            this.style.opacity = 1;
            this.style.cursor = 'pointer';
        }
        if (this.icon) {
            this.style.backgroundImage = `url('${this.icon}')`;
            this.style.backgroundSize = '2em';
            this.style.width = '2em';
            this.style.height = '2em';
            this.style.backgroundPosition = 'center';
            this.style.backgroundRepeat = 'no-repeat';
        }
    }
}

class SimpleModal extends HTMLElement {
    static get observedAttributes() { return ['template']; }
    constructor() {
        super();
        this.attachShadow({ mode: 'open' });


    }
    connectedCallback() {
    }

    disconnectedCallback() {

    }

    attributeChangedCallback(name, oldValue, newValue) {
        if (name == 'template') {
            let template = document.getElementById(newValue);
            if (template) {
                let templateContent = template.content;
                this.shadowRoot.innerHTML = '';
                this.shadowRoot.appendChild(templateContent.cloneNode(true));
            }
        }


    }
}

export class SimpleUI {

    static disableModal(...names) {
        const modals = document.querySelectorAll(`simple-modal`);
        for (let modal of modals) {

            if (names.length == 0 || names.includes(modal.getAttribute('name'))) {
                modal.setAttribute('hidden', '');
            }

        }
    }
    static enableModal(...names) {
        if (!names)
            return;
        const modals = document.querySelectorAll(`simple-modal`);
        for (let modal of modals) {
            if (names.includes(modal.getAttribute('name'))) {
                modal.removeAttribute('hidden', '');
            } else {
                modal.setAttribute('hidden', '');
            }
        }
    }
    static disableAction(...actions) {
        const buttons = document.querySelectorAll(`[action]`);
        for (let button of buttons) {
            if (actions.includes(button.getAttribute('action'))) {
                button.setAttribute('disabled', '');
            }
        }
    }
    static enableAction(...actions) {
        const buttons = document.querySelectorAll(`[action]`);
        for (let button of buttons) {
            if (actions.includes(button.getAttribute('action'))) {
                button.removeAttribute('disabled');
            }
        }
    }
    static on(action, callback) {
        signal.on(action, callback);
    }
}

window.customElements.define('simple-toolbar', SimpleToolbar);
window.customElements.define('simple-button', SimpleButton);
window.customElements.define('simple-modal', SimpleModal);
